export default __webpack_public_path__ + "static/media/google-setup-3.58e8c7e7.jpeg";